export const filterMembershipsGiftsRedeems = (item) => {
    return !(item.type === 'GIFT_REDEEM' && item.orderId === '00000000-0000-0000-0000-000000000000');
};
